// reducers/invitation.js

import { FETCH_INVITATION_DETAILS_REQUEST, FETCH_INVITATION_DETAILS_SUCCESS, FETCH_INVITATION_DETAILS_FAILURE } from '../actions/invitation';
import { USER_LOGOUT } from '../actions/types';

const initialState = {
  details: null,
  isLoading: false,
  error: null,
  hasLoaded: false
};

const invitationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INVITATION_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null
      };

    case FETCH_INVITATION_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        details: action.payload,
        error: null,
        hasLoaded: true
      };

    case FETCH_INVITATION_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        details: null,
        hasLoaded: true
      };

    case USER_LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default invitationReducer;
